import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { shapes } from '@cimpress/react-components';

import '../css/imageLoader.css';

import { downloadImage } from '../util/url';

export default class ImageLoader extends Component {
    state = {
        latestRequestNumber: 0,
        lastRenderedRequest: 0,
        imageUrl: '',
    }

    componentWillMount() {
        this.downloadImage(this.props.url);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.url !== nextProps.url) {
            this.downloadImage(nextProps.url);
        }
    }

    downloadImage = (url) => {
        if (!url) {
            return;
        }
        const { latestRequestNumber } = this.state;

        const requestNumber = latestRequestNumber + 1;
        this.setState({ latestRequestNumber: requestNumber });

        downloadImage(url)
            .then((image) => {
                if (requestNumber > this.state.lastRenderedRequest) {
                    this.setState({ imageUrl: image.src, lastRenderedRequest: requestNumber });
                }
            })
            .catch((errorResponse) => {
                console.error(errorResponse);
            });
    }

    render() {
        const { alt, className } = this.props;
        const { imageUrl, latestRequestNumber, lastRenderedRequest } = this.state;
        const { Spinner } = shapes;
        const loadingClass = latestRequestNumber !== lastRenderedRequest ? ' image-loader__spinner--loading' : '';
        return (
            <div className={`image-loader ${className}`}>
                <img className='image-loader__image' src={imageUrl} alt={alt} />
                <Spinner className={`image-loader__spinner${loadingClass}`} size={50} />
            </div>
        );
    }
}

ImageLoader.propTypes = {
    url: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/ImageLoader.jsx